var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.run ? _c('div', {
    attrs: {
      "id": "preloader"
    }
  }, [_vm._m(0)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "line-scale"
  }, [_c('div'), _c('div'), _c('div'), _c('div'), _c('div')])]);
}]

export { render, staticRenderFns }